const is = require('../plugins/helper/is')
const { listen } = require('../plugins/event/listen')

if (is.node('#grupo-familiar-inputs')) {
  const content = is.getNode('#grupo-familiar-inputs')
  let index = content.children ? content.children.length : 1
  listen('#id-add-family-group', 'click', () => {
    const insert = is.make('div', { 'class': 'row' }, [
      is.make('div', { 'class': 'col-md-4' }, [
        is.make('div', { 'class': 'form-group' }, [
          is.make('label', { 'class': 'control-label' }, [is.text(`Nombre ${index + 1}`)]),
          is.make('input', { 'class': 'form-control', 'name': `grupo_familiar[${index}][nombre]` }),
        ]),
      ]),
      is.make('div', { 'class': 'col-md-4' }, [
        is.make('div', { 'class': 'form-group' }, [
          is.make('label', { 'class': 'control-label' }, [is.text(`Cédula ${index + 1}`)]),
          is.make('input', { 'class': 'form-control', 'name': `grupo_familiar[${index}][cedula]` }),
        ]),
      ]),
      is.make('div', { 'class': 'col-md-4' }, [
        is.make('div', { 'class': 'form-group' }, [
          is.make('label', { 'class': 'control-label' }, [is.text(`Parentesco ${index + 1}`)]),
          is.make('input', { 'class': 'form-control', 'name': `grupo_familiar[${index}][parentesco]` }),
        ]),
      ]),
    ])
    content.appendChild(insert)
    index++

    return false
  })
}
